export default __webpack_public_path__ + "4dca06f15b5175a24bc07d5817401f4a.png";